/**
 * Quem ocupa o espaço: o Google ou o anúncio próprio. Os dois podendo, sorteia
 * pela fatia do próprio (`houseShare`, % das vezes). Nenhum, null.
 */
export function escolherFonte(entrada: {
  temGoogle: boolean;
  temProprio: boolean;
  houseShare: number;
  sorteio?: () => number;
}): 'google' | 'proprio' | null {
  const { temGoogle, temProprio, houseShare, sorteio = Math.random } = entrada;
  if (temGoogle && temProprio) return sorteio() * 100 < Math.min(100, Math.max(0, houseShare)) ? 'proprio' : 'google';
  if (temGoogle) return 'google';
  if (temProprio) return 'proprio';
  return null;
}
